import React, { useState } from "react";
import folderIcon from "../assets/folder.png";
import noImage from "../assets/photo.png";
import { IMAGE_BASE } from "../api";

/* ── inline SVG icons ── */
const IcoTrash = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
    <path d="M10 11v6M14 11v6M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  </svg>
);

const IcoCopy = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2"/>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
  </svg>
);

const IcoPencil = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

const IcoEye = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

/* ── helpers ── */
const buildUrl = (path, name) => {
  const segs = [];
  if (path) path.split("/").forEach((s) => s && segs.push(encodeURIComponent(s)));
  if (name) segs.push(encodeURIComponent(name));
  return `${IMAGE_BASE}/images/${segs.join("/")}`;
};

// Anh thu nho (server tu sinh + cache) chi dung cho luoi hien thi, giup may
// yeu khong phai tai/giai ma anh goc full-size. Xem/tai/copy link van dung buildUrl().
const buildThumbUrl = (path, name) => {
  const segs = [];
  if (path) path.split("/").forEach((s) => s && segs.push(encodeURIComponent(s)));
  if (name) segs.push(encodeURIComponent(name));
  return `${IMAGE_BASE}/images/_thumb/${segs.join("/")}`;
};

const formatSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

const isVideo = (n) => /\.(mp4|mov|avi|mkv|webm|m4v|wmv|flv|3gp)$/i.test(n);
const isPdf   = (n) => /\.pdf$/i.test(n);

/* ══════════════════════════════════════════════════ */
export default function ExplorerView({
  role, folders = [], images = [], path, search = "",
  onBack, onOpenFolder,
  onDeleteFolder, onDeleteImage,
  onRenameFolder, onRenameImage,
}) {
  const [renameTarget, setRenameTarget] = useState(null);
  const [newName, setNewName]           = useState("");
  const [copied, setCopied]             = useState(null);

  const askRename = (name) => { setRenameTarget(name); setNewName(name); };

  const confirmRename = () => {
    if (!newName.trim()) return;
    if (newName === renameTarget) { setRenameTarget(null); return; }
    const isFile = images.some((i) => i.name === renameTarget);
    if (isFile) onRenameImage(renameTarget, newName);
    else if (role === "admin") onRenameFolder(renameTarget, newName);
    setRenameTarget(null);
  };

  const copyUrl = (url) => {
    const done = () => { setCopied(url); setTimeout(() => setCopied(null), 1800); };
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(done).catch(() => fallbackCopy(url, done));
    } else {
      fallbackCopy(url, done);
    }
  };

  const fallbackCopy = (url, done) => {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); done(); } catch {}
    document.body.removeChild(ta);
  };

  const keyword = (search || "").toLowerCase();
  const filteredFolders = folders.filter((f) => f.toLowerCase().includes(keyword));
  const filteredImages  = images.filter((i) => i?.name && i.name.toLowerCase().includes(keyword));

  return (
    <div className="explorer-wrapper">
      {path && (
        <button className="back-btn" onClick={onBack}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
          Quay lại
        </button>
      )}

      {/* ── FOLDERS ── */}
      {filteredFolders.length > 0 && (
        <>
          <div className="section-title">Thư mục</div>
          <div className="folder-grid">
            {filteredFolders.map((f) => {
              const folderUrl = buildUrl(path, f);
              return (
                <div key={f} className="folder-item" onClick={() => { if (renameTarget !== f) onOpenFolder(f); }}>
                  <img src={folderIcon} className="folder-icon" alt="" />

                  {renameTarget === f ? (
                    <div onClick={(e) => e.stopPropagation()}>
                      <input
                        className="rename-input"
                        value={newName}
                        autoFocus
                        onChange={(e) => setNewName(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter") confirmRename(); if (e.key === "Escape") setRenameTarget(null); }}
                      />
                      <div className="rename-actions">
                        <button className="btn small" onClick={confirmRename}>Lưu</button>
                        <button className="btn small cancel" onClick={() => setRenameTarget(null)}>Hủy</button>
                      </div>
                    </div>
                  ) : (
                    <div className="folder-name">{f}</div>
                  )}

                  {renameTarget !== f && (
                    <div className="folder-hover-overlay">
                      <button className={`overlay-btn ${copied === folderUrl ? "copied" : ""}`} onClick={(e) => { e.stopPropagation(); copyUrl(folderUrl); }} title="Sao chép link">
                        {copied === folderUrl
                          ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                          : <IcoCopy />}
                      </button>
                      {role === "admin" && (
                        <>
                          <button className="overlay-btn" onClick={(e) => { e.stopPropagation(); askRename(f); }} title="Đổi tên">
                            <IcoPencil />
                          </button>
                          {onDeleteFolder && (
                            <button className="overlay-btn overlay-danger" onClick={(e) => { e.stopPropagation(); onDeleteFolder(f); }} title="Xóa">
                              <IcoTrash />
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* ── FILES ── */}
      <div className="section-title">Hình ảnh / Video / PDF</div>
      <div className="image-grid">
        {filteredImages.map((item) => {
          const url = buildUrl(path, item.name);
          const thumbUrl = buildThumbUrl(path, item.name);
          const isCopied = copied === url;

          return (
            <div key={item.name} className="image-card">
 
              <div className="thumb-wrap">
                {isPdf(item.name) ? (
                  <div className="pdf-preview" onClick={() => window.open(url, "_blank")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#FEE2E2" stroke="#DC2626" strokeWidth="1.5"/>
                      <polyline points="14,2 14,8 20,8" fill="none" stroke="#DC2626" strokeWidth="1.5"/>
                      <text x="12" y="17" textAnchor="middle" fill="#DC2626" fontSize="5" fontWeight="bold">PDF</text>
                    </svg>
                    <span className="pdf-label">PDF</span>
                  </div>
                ) : isVideo(item.name) ? (
                  <video className="image-thumb" src={url} controls preload="metadata" />
                ) : (
                  <img
                    src={thumbUrl}
                    className="image-thumb"
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
              
                      if (e.target.src !== url) {
                        e.target.src = url;
                      } else {
                        e.target.onerror = null;
                        e.target.src = noImage;
                      }
                    }}
                    alt=""
                  />
                )}
 
                <div className="thumb-overlay">
                  {isPdf(item.name) && (
                    <button className="overlay-btn" onClick={() => window.open(url, "_blank")} title="Xem">
                      <IcoEye />
                    </button>
                  )}
                  <button
                    className={`overlay-btn ${isCopied ? "copied" : ""}`}
                    onClick={() => copyUrl(url)}
                    title="Sao chép link"
                  >
                    {isCopied ? (
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                    ) : (
                      <IcoCopy />
                    )}
                  </button>
                  {onDeleteImage && (
                    <button className="overlay-btn overlay-danger" onClick={() => onDeleteImage(item.name)} title="Xóa">
                      <IcoTrash />
                    </button>
                  )}
                </div>
              </div>
 
              <div className="image-info">
                {renameTarget === item.name ? (
                  <div className="rename-inline">
                    <input
                      className="rename-input-inline"
                      value={newName}
                      autoFocus
                      onChange={(e) => setNewName(e.target.value)}
                      onKeyDown={(e) => { if (e.key === "Enter") confirmRename(); if (e.key === "Escape") setRenameTarget(null); }}
                    />
                    <div className="rename-actions">
                      <button className="btn small" onClick={confirmRename}>Lưu</button>
                      <button className="btn small cancel" onClick={() => setRenameTarget(null)}>Hủy</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="image-name" title={item.name}>{item.name}</div>
                    <div className="image-meta">
                      {item.size > 0 && <span className="image-size">{formatSize(item.size)}</span>}
                      <button className="rename-link" onClick={() => askRename(item.name)}>
                        <IcoPencil /> Đổi tên
                      </button>
                    </div>
                    {isPdf(item.name) && (
                      <button
                        className="btn small download"
                        style={{ marginTop: 6, width: "100%" }}
                        onClick={() => { const a = document.createElement("a"); a.href = url; a.download = item.name; a.click(); }}
                      >
                        Tải PDF
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}

        {filteredImages.length === 0 && (
          <div className="empty-state">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            <p>Không có file nào</p>
          </div>
        )}
      </div>
    </div>
  );
}
